Jelly.Debug = 
{
	// Debug mode flag values
	Level: 
	{ 
		None: "None",
		Errors_Only: "Errors Only",
		All: "All"
	},
	
	// Global debug mode flag
	Debug_Mode: "All",
	Alert_Errors: false,
	
	// TODO: doesn't seem to be used.
	End_Early: 0
}